export default {
  wordpress: 'wordpress',
  trackingCode: 'trackingCode'
};